import { useState } from "react";
import { VscChromeClose } from "react-icons/vsc";
import { BsStopCircle } from "react-icons/bs";
import { TbRefresh } from "react-icons/tb";
import { GoPlus } from "react-icons/go";
import { TbFileReport } from "react-icons/tb";
import { Link } from "react-router-dom";
import CaseActionItems from "./CaseActionItems";
import Swal from "sweetalert2";
import { IconType } from "react-icons";
import { all_routes } from "../../../router/all_routes";
import useApi from "../../../../core/customhook/useApi";
import webservice_url from "../../../../core/webservice/Webservice_url";
import CaseActionModal, {
  ActionField,
} from "../../../admin/track-case-program/work-in-progress/CaseActionModal";
import { ReactIcon } from "../../../../core/common/ReactIconWrapper";
import useLocalStorage from "../../../../core/customhook/hooks/useLocalStorage";

interface TabType {
  value: string;
  label: string;
  icon: IconType;
  color: string;
  bg: string;
  link: string;
}

interface CaseActionsProps {
  caseDetail?: {
    applicant_name?: string;
    case_id?: string;
    case_receive_date?: string;
    sla_start_date?: string;
    ordered_by?: string;
    due_date?: string;
    case_stopped_at?: string;
    assignment_id?: string;
    current_status?: string; // 👈 add this
  };
  assignmentId?: string;
  onSuccess?: () => void;
}

type ActiveAction = "stop_case" | "resume_case" | "submit_insuff_expire" | null;

type ModalConfigItem = {
  title: string;
  confirmLabel: string;
  confirmButtonClass: string;
  reasonLabel: string;
  statusName: string;
};

const CaseActions = ({
  caseDetail,
  onSuccess,
  assignmentId,
}: CaseActionsProps) => {
  const { getLocalStorage } = useLocalStorage();
  const [activeAction, setActiveAction] = useState<ActiveAction>(null);
  const [loading, setLoading] = useState(false);

  const tabs: TabType[] = [
    {
      value: "stop_case",
      label: "Stop Case",
      icon: VscChromeClose,
      color: "text-danger",
      link: "#",
      bg: "#FEECEC",
    },
    {
      value: "stop_check",
      label: "Stop Check",
      icon: BsStopCircle,
      color: "text-warning",
      link: all_routes.verifier_caseStopCheck,
      bg: "#FFF8E6", // Stop Check
    },
    {
      value: "resume_case",
      label: "Resume Case",
      icon: TbRefresh,
      color: "text-secondary",
      link: "#",
      bg: "#EEF4FF",
    },
    {
      value: "add_check",
      label: "Add Check",
      icon: GoPlus,
      color: "text-success",
      link: all_routes.verifier_caseAddCheck,
      bg: "#EAFBF2",
    },
    // {
    //   value: "submit_insuff_expire",
    //   label: "Submit Insuff Expire",
    //   icon: TbRefresh,
    //   color: "text-primary",
    //   link: "#",
    //   bg: "#F4EDFF",
    // },
    // {
    //   value: "generate_report",
    //   label: "Generate Report",
    //   icon: TbFileReport,
    //   color: "text-info",
    //   link: "#",
    //   bg: "#EAF7FF", // Report
    // },
  ];

  // 👇 normalize status once
  const normalizedStatus = caseDetail?.current_status?.trim()?.toUpperCase();

  const visibleTabs = tabs.filter((tab) => {
    switch (normalizedStatus) {
      case "STOP":
        // Hide Stop button
        return tab.value !== "stop_case";

      case "WORK IN PROGRESS":
      case "SUBMITED":
        // Hide Resume button
        return tab.value !== "resume_case";

      case "CANCELLED":
        // Hide both Resume & Stop buttons
        return tab.value !== "resume_case" && tab.value !== "stop_case";

      default:
        return true;
    }
  });
  const getCaseStatuses = useApi<any>(webservice_url.GetCaseStatus, {
    method: "GET",
    autoCall: true,
    handleGlobalError: false,
  });

  const caseStatusUpdateAPI = useApi<any>(webservice_url.updateCaseStatus, {
    method: "PATCH",
    autoCall: false,
    handleGlobalError: false,
  });

  const getStatusIdByName = (statusName: string): string | undefined => {
    const statusList = getCaseStatuses?.data?.data ?? [];
    return statusList.find((s: any) => s.status_name === statusName)?.status_id;
  };
  const getModalFields = (action: ActiveAction): ActionField[] => {
    switch (action) {
      case "stop_case":
        return [
          { label: "Case ID", value: caseDetail?.case_id },
          { label: "Candidate Name", value: caseDetail?.applicant_name },
          {
            label: "Case Received Date",
            value: caseDetail?.case_receive_date,
            isDate: true,
          },
          {
            label: "SLA Start Date",
            value: caseDetail?.sla_start_date,
            isDate: true,
          },
          { label: "Due Date", value: caseDetail?.due_date, isDate: true },
        ];
      case "resume_case":
        return [
          { label: "Case ID", value: caseDetail?.case_id },
          { label: "Candidate Name", value: caseDetail?.applicant_name },
          {
            label: "Case Received Date",
            value: caseDetail?.case_receive_date,
            isDate: true,
          },
          {
            label: "Case Stopped Date",
            value: caseDetail?.case_stopped_at,
            isDate: true,
          },
        ];
      case "submit_insuff_expire":
        return [
          // { label: "Case ID", value: caseDetail?.case_id },
          // { label: "Candidate Name", value: caseDetail?.applicant_name },
          // {
          //   label: "Case Received Date",
          //   value: caseDetail?.case_receive_date,
          //   isDate: true,
          // },
          // {
          //   label: "Case Stopped Date",
          //   value: caseDetail?.case_stopped_at,
          //   isDate: true,
          // },
          // {
          //   label: "Assigned By",
          //   value: caseDetail?.ordered_by,
          // },
          { label: "Case ID", value: caseDetail?.case_id },
          { label: "Candidate Name", value: caseDetail?.applicant_name },
          {
            label: "Case Received Date",
            value: caseDetail?.case_receive_date,
            isDate: true,
          },
          {
            label: "SLA Start Date",
            value: caseDetail?.sla_start_date,
            isDate: true,
          },
          { label: "Due Date", value: caseDetail?.due_date, isDate: true },
        ];
      default:
        return [];
    }
  };

  const modalConfig: Record<Exclude<ActiveAction, null>, ModalConfigItem> = {
    stop_case: {
      title: "Stop Case",
      confirmLabel: "Stop Case",
      confirmButtonClass: "btn-danger",
      reasonLabel: "Enter reason of stopping case",
      statusName: "STOP",
    },
    resume_case: {
      title: "Resume Case",
      confirmLabel: "Resume Case",
      confirmButtonClass: "btn-secondary",
      reasonLabel: "Enter reason of resuming case",
      statusName: "WORK IN PROGRESS",
    },
    submit_insuff_expire: {
      title: "Submit Insuff Expire",
      confirmLabel: "Submit",
      confirmButtonClass: "btn-primary",
      reasonLabel: "Enter reason for insuff expire",
      statusName: "INSUFF_EXPIRED",
    },
  };

  const handleActionClick = (value: string) => {
    if (
      value === "stop_case" ||
      value === "resume_case" ||
      value === "submit_insuff_expire"
    ) {
      setActiveAction(value);
    }
  };

  const handleConfirm = async (reason: string) => {
    if (!activeAction) return;
    const storedAuth = getLocalStorage("auth");
    const actorId = storedAuth?.agency_user_id || "";
    try {
      setLoading(true);

      const config = modalConfig[activeAction];
      const statusId = getStatusIdByName(config.statusName);

      if (!statusId) {
        Swal.fire({
          title: "Error",
          text: `Status "${config.statusName}" not found. Please refresh and try again.`,
          icon: "error",
        });
        return;
      }

      await caseStatusUpdateAPI.callApi({
        case_id: caseDetail?.case_id,
        status: statusId,
        actor_id: actorId,
        actor_type: "admin",
        action_reason: reason,
      });

      setActiveAction(null);
      onSuccess?.();

      await Swal.fire({
        title: "Success!",
        text: `${config.title} completed.`,
        icon: "success",
        timer: 1500,
        // showConfirmButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#f26522",
        allowOutsideClick: false,
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error",
        text: "Something went wrong. Please try again.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`

.case-actions-toolbar{

    display:flex;
    flex-wrap:wrap;
    gap:12px;

    padding:18px;

}

.case-action-btn{

    display:flex;
    align-items:center;
    gap:10px;

    padding:10px 16px;

    background:#fff;

    border:1px solid #E5E7EB;

    border-radius:8px;

    text-decoration:none;

    transition:.25s;

    color:#374151;

    font-size:14px;

    font-weight:500;

    min-width:170px;

}

.case-action-btn:hover{

    background:#F8FAFC;

    border-color:#0d6efd;

    color:#0d6efd;

    box-shadow:0 4px 12px rgba(0,0,0,.08);

    transform:translateY(-2px);

}

.case-action-icon{

    width:34px;

    height:34px;

    display:flex;

    align-items:center;

    justify-content:center;

    border-radius:8px;

    background:#F3F4F6;

    font-size:18px;

    flex-shrink:0;

}

.case-action-text{

    white-space:nowrap;

}

.case-action-btn:hover .case-action-icon{

    background:#E8F1FF;

}

`}</style>
      <div className="card mt-3">
        {/* <div
          className="py-2 d-flex flex-nowrap align-items-center"
          style={{ overflowX: "auto", overflowY: "hidden" }}
        >
          {tabs?.map((i, idx) => (
            <Link
              to={i.link}
              key={i.value}
              className={`${i.color} py-1 d-flex gap-1 justify-content-center align-items-center flex-grow-1 px-3 ${idx < tabs.length - 1 ? "border-end" : ""} `}
              style={{ minWidth: "max-content", cursor: "pointer" }}
              onClick={(e) => { if (i.link === "#") { e.preventDefault(); handleActionClick(i.value)}
              }}
            >
              <ReactIcon icon={i.icon} />
              <div className="small">{i.label}</div>
            </Link>
          ))}
        </div> */}
        {/* <div className="case-actions-toolbar">
          {visibleTabs?.map((item) => (
            <Link
              key={item.value}
              to={item.link}
              state={{
                caseDetails: caseDetail,
                assignment_id: assignmentId,
              }}
              className="case-action-btn"
              onClick={(e) => {
                if (item.link === "#") {
                  e.preventDefault();
                  handleActionClick(item.value);
                }
              }}
            >
              <span
                className={`case-action-icon ${item.color}`}
                style={{
                  background: item.bg,
                }}
              >
                <ReactIcon icon={item.icon} />
              </span>

              <span className="case-action-text">{item.label}</span>
            </Link>
          ))}
        </div> */}
      </div>

      <CaseActionItems caseDetail={caseDetail} assignmentId={assignmentId} />

      {activeAction && (
        <CaseActionModal
          isOpen={!!activeAction}
          title={modalConfig[activeAction].title}
          confirmLabel={modalConfig[activeAction].confirmLabel}
          confirmButtonClass={modalConfig[activeAction].confirmButtonClass}
          reasonLabel={modalConfig[activeAction].reasonLabel}
          onClose={() => setActiveAction(null)}
          onConfirm={handleConfirm}
          baseFields={getModalFields(activeAction)}
          extraFields={[]}
          loading={loading}
        />
      )}
    </>
  );
};

export default CaseActions;
